import React from 'react';
import { Row, Col, Form, Button, Card } from 'react-bootstrap';
import { useFieldArray, Controller } from 'react-hook-form';
import { FaPlus, FaTimes, FaCloudUploadAlt } from 'react-icons/fa';
import FormInput from '../../form/FormInput';

const StepEducation = ({ control, errors }) => {
    const { fields, append, remove } = useFieldArray({
        control,
        name: "educations"
    });

    const years = Array.from({ length: 40 }, (_, i) => String(new Date().getFullYear() - i));

    return (
        <div className="animate-fade-in">
            <div className="d-flex justify-content-between align-items-center mb-4 border-bottom border-secondary pb-2">
                <h6 className="text-uppercase text-white fw-bold m-0">
                    <span className="text-danger border-start border-4 border-danger ps-3">Training & Education</span>
                </h6>
                <Button 
                    variant="outline-danger" 
                    size="sm"
                    className="fw-bold px-3"
                    onClick={() => append({
                        instituteName: '', courseDegree: '', startYear: '', endYear: '',
                        cityTown: '', description: '', certificateFile: null
                    })}
                >
                    <FaPlus className="me-2" /> ADD EDUCATION
                </Button>
            </div>

            {fields.map((field, index) => (
                <Card key={field.id} className="bg-transparent border-secondary mb-4 p-3 position-relative" style={{ borderStyle: 'dashed' }}>
                    
                    <button 
                        type="button"
                        className="btn-close btn-close-white position-absolute" 
                        style={{ top: '15px', right: '15px', padding: '0.5rem' }} 
                        onClick={() => remove(index)}
                    />

                    <Row className="mt-2">
                        <Col md={4}>
                            <FormInput 
                                name={`educations.${index}.instituteName`} 
                                label="Institute / School Name" 
                                control={control} 
                                errors={errors} 
                            />
                        </Col>
                        <Col md={4}>
                            <FormInput 
                                name={`educations.${index}.courseDegree`} 
                                label="Course / Degree Name" 
                                control={control} 
                                errors={errors} 
                            />
                        </Col>
                        <Col md={4}>
                            <FormInput 
                                name={`educations.${index}.cityTown`} 
                                label="City / Town" 
                                control={control} 
                                errors={errors} 
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col md={3}>
                            <Form.Group className="mb-4">
                                <Form.Label className="form-label text-white">Start Year</Form.Label>
                                <Controller
                                    name={`educations.${index}.startYear`}
                                    control={control}
                                    render={({ field: { onChange, value } }) => (
                                        <Form.Select className="bg-dark text-white border-secondary" value={value || ''} onChange={onChange}>
                                            <option value="">Select Year</option>
                                            {years.map(y => <option key={y} value={y}>{y}</option>)}
                                        </Form.Select>
                                    )}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group className="mb-4">
                                <Form.Label className="form-label text-white">End Year (Or Pursuing)</Form.Label>
                                <Controller
                                    name={`educations.${index}.endYear`}
                                    control={control}
                                    render={({ field: { onChange, value } }) => (
                                        <Form.Select className="bg-dark text-white border-secondary" value={value || ''} onChange={onChange}>
                                            <option value="">Select Year</option>
                                            <option value="Pursuing">Pursuing</option>
                                            {years.map(y => <option key={y} value={y}>{y}</option>)}
                                        </Form.Select>
                                    )}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-4">
                                <Form.Label className="form-label">Upload Certificate / Degree</Form.Label>
                                <Controller
                                    name={`educations.${index}.certificateFile`}
                                    control={control}
                                    render={({ field: { onChange, value } }) => (
                                        <div className="d-flex align-items-center bg-dark text-white rounded border border-secondary" style={{ overflow: 'hidden' }}>
                                            <span className="flex-grow-1 px-3 text-truncate small text-secondary">
                                                {value instanceof File ? value.name : (field.certificateUrl ? "Attached Certificate" : "Choose file")}
                                            </span>
                                            <label 
                                                htmlFor={`edu-file-upload-${index}`} 
                                                className="btn btn-secondary m-0 rounded-0 px-4" 
                                                style={{ cursor: 'pointer' }}
                                            >
                                                Browse
                                            </label>
                                            <input 
                                                type="file" 
                                                id={`edu-file-upload-${index}`} 
                                                className="d-none" 
                                                onChange={(e) => onChange(e.target.files[0])} 
                                            />
                                        </div>
                                    )}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={12}>
                            <FormInput 
                                name={`educations.${index}.description`} 
                                label="More Details / Description" 
                                control={control} 
                                errors={errors} 
                                as="textarea" 
                                rows={3}
                            />
                        </Col>
                    </Row>
                </Card>
            ))}

            {fields.length === 0 && (
                <div className="text-center text-secondary py-5 bg-dark rounded border border-secondary" style={{ borderStyle: 'dashed' }}>
                    No training or education details added yet. Click "+ ADD EDUCATION" to begin.
                </div>
            )}
        </div>
    );
};

export default StepEducation;